/**
 * #501: chat date/time labels must come from the message's own timestamp, never
 * from `new Date()` (which showed today's date for every chat regardless of when
 * the messages were actually sent). Both return "" for a missing/invalid value
 * so callers can hide the label instead of falling back to "now".
 */

export function formatChatDate(ts) {
  if (!ts) return '';
  try {
    return new Date(ts).toLocaleDateString('en-US', {
      weekday: 'long',
      day: 'numeric',
      month: 'long',
      year: 'numeric',
    });
  } catch {
    return '';
  }
}

export function formatChatTime(ts) {
  if (!ts) return '';
  try {
    return new Date(ts).toLocaleTimeString('en-US', {
      hour: 'numeric',
      minute: '2-digit',
    });
  } catch {
    return '';
  }
}
